<template>
  <dd-header-card header="Selecteer uw dekkingen" data-dusk="choose-coverages">
    <template #action>
      <a-dropdown>
        <a-menu slot="overlay">
          <a-menu-item
              v-for="viewOption in allAvailableViewOptions"
              :key="viewOption.id"
              @click="addCoverage(viewOption.id)"
              :data-dusk="'add-coverage-' + viewOption.id"
          >
            {{ viewOption.name }}
          </a-menu-item>
        </a-menu>
        <dd-button :small="true" :outline="true">
          <template #icon>
            <CardPlusIcon class="icon-size-md"/>
          </template>
          Toevoegen
        </dd-button>
      </a-dropdown>
    </template>
    <div class="flex-col gap-y-sm">
      <dd-header-card
          v-for="(view) in views"
          :header="view.name"
          :key="view.uuid"
          :nested="true"
      >
        <template #action>
          <TrashIcon @click="onViewDeselect(view.uuid)" class="fill-danger"></TrashIcon>
        </template>
      </dd-header-card>
    </div>
  </dd-header-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import _ from "lodash";
import policyViewApi from "~/api/policy_view";

export default {
  name: "ChooseCoverages",
  computed: {
    ...mapState(`$_generic_insurance`, {
      views: state => state.form?.views,
      policyId: state => state.policyId,
    }),
    ...mapGetters(`$_generic_insurance`, {
      fieldsGroupedByView: "fieldsGroupedByView",
      requiredViews: "requiredViews",
      optionalViews: "optionalViews",
      viewOptions: "views",
    }),
    allAvailableViewOptions() {
      // Filter requiredViews from optionalViews (prevent duplicates)
      let optionalValues = this.optionalViews.filter(optionalValue => {
        return !this.requiredViews.find(requiredView => requiredView.id === optionalValue.id);
      });

      return [...this.requiredViews, ...optionalValues];
    }
  },
  methods: {
    addCoverage(id) {
      // Get a single renderable view by view_id. Append to form.views
      if (this.policyId) {
        policyViewApi.findRenderableInputsByPolicyAndView(this.policyId, id)
            .then((view) => {
              this.pushViewToForm(view);
            });
      } else {
        policyViewApi.findRenderableInputsById(id)
            .then((view) => {
              this.pushViewToForm(view);
            });
      }
    },
    debounceGetViews: _.debounce(function () {
      this.loadingViews(true);
      this.getViews();
    }, 400),
    ...mapActions(`$_generic_insurance`, {
      getViews: "getViews",
      getViewOptions: "getViewOptions",
      deleteCoverage: "deleteCoverage",
    }),
    ...mapMutations(`$_generic_insurance`, {
      loadingViews: "LOADING_VIEWS",
      deleteView: "DELETE_VIEW",
      setPolicyViewIds: "SET_POLICY_VIEW_ID",
      pushViewToForm: "PUSH_VIEW_TO_FORM",
    }),
    onViewDeselect(deselectedViewId) {
      // TODO: add confirm window (with (some) data contained in the coverage)
      // TODO: add feedback to user if the coverage cannot be deleted
      this.deleteCoverage(deselectedViewId);
    },
  }
};
</script>

<style scoped>

</style>
